import React, { useState, useEffect} from 'react';

import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import DateRangePicker from '../../../Components/dateRangePicker';
import Button from '../../../Components/Button';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';

import '../../../Assets/css/toast.css';
import { use } from 'react';

const CreateRent = () => {
    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);
    const userId ={userID: decodedToken.id};

    //---------create Recharge modal-----------
    const [productList, setProductList] = useState([]);
    const fetchProduct = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const response = await axios.post(`${POCBaseUrl}/products/get`,
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                setProductList(response.data.data);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }
    

    const [customerList, setCustomerList] = useState([]);
    const fetchCustomer = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            const response = await axios.post(`${POCBaseUrl}/debtors/getcustomer`,
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                setCustomerList(response.data.data);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }
    }

    useEffect(()=> {
        fetchProduct();
        fetchCustomer();
    },[])
    //---------------handle customer----------------
    const [addCustomerOpen, setAddCustomerOpen] = useState(false);
    const [newCustomer,setNewCustomer] = useState({number:'', name:'', email:'', phone:'',address1: '', address2: '', address3:'',postal_code:''});
    const handleCustomerChange = (e) => {
        const { name, value } = e.target;
        setNewCustomer(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const handleCustomerCreate = async(e) => {
        e.preventDefault();

        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if (newCustomer.number !== '') {
            } else {
              toast.warn("Please input a number", {
                  className: 'centered-toast0',
                  bodyClassName: 'centered-body',
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeButton: false,
                  pauseOnHover: false,
                  draggable: true,
                });
              return;
            }
            if (newCustomer.name !== '') {
            } else {
              toast.warn("Please input a name", {
                  className: 'centered-toast0',
                  bodyClassName: 'centered-body',
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeButton: false,
                  pauseOnHover: false,
                  draggable: true,
                });
              return;
            }
            if (newCustomer.email !== '') {
            } else {
              toast.warn("Please input a email", {
                  className: 'centered-toast0',
                  bodyClassName: 'centered-body',
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeButton: false,
                  pauseOnHover: false,
                  draggable: true,
                });
              return;
            }
            if (newCustomer.phone !== '') {
            } else {
              toast.warn("Please input a Phone Number", {
                  className: 'centered-toast0',
                  bodyClassName: 'centered-body',
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeButton: false,
                  pauseOnHover: false,
                  draggable: true,
                });
              return;
            }
            if (newCustomer.address1 !== '') {
            } else {
              toast.warn("Please input a Address", {
                  className: 'centered-toast0',
                  bodyClassName: 'centered-body',
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeButton: false,
                  pauseOnHover: false,
                  draggable: true,
                });
              return;
            }
            const response = await axios.post(`${POCBaseUrl}/debtors/createcustomer`, {newCustomer},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                toast.success('NewCustomer added successfully!', {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    // draggable: true,
                    pauseOnFocusLoss: true
                  });
                  setAddCustomerOpen(false);
                  fetchCustomer();
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };
    //----------------------------------------------

    const [productData, setProductData] = useState({name:'', price: 0, stock: 0, seller: '', category: '', brand : ''});
    const [debtorData, setDebtorData] = useState({allproduct:[{id:'',quantity:0}], total_price: 0, contractor:'',start_date:'',end_date:'', status:'Pending',contract_date:''});

    const handleProductChange = (e) => {
        const { name, value } = e.target;

        // Check if the change is from the select box or the quantity input
        if (name === 'id') {
            const selectedProduct = productList.find(item => item._id === value);
            const newTotalPrice = selectedProduct ? selectedProduct.price * debtorData.allproduct[0].quantity : 0;
            setDebtorData(prevState => ({
                ...prevState,
                allproduct: [{ id: value, quantity: prevState.allproduct[0].quantity }],
                total_price: newTotalPrice,
            }));
        } else if (name === 'quantity') {
            // Update the quantity and recalculate total price
            const newQuantity = value;
            const selectedProduct = productList.find(item => item._id === debtorData.allproduct[0].id);
            const newTotalPrice = selectedProduct ? selectedProduct.price * newQuantity : 0;

            setDebtorData(prevState => ({
                ...prevState,
                allproduct: [{ ...prevState.allproduct[0], quantity: newQuantity }],
                total_price: newTotalPrice,
            }));
        } else {
            setDebtorData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }

    };

    const date = new Date();
    const formattedDate = date.toISOString().split('T')[0]; // Outputs in YYYY-MM-DD format

    const handleDataFromChild = (startDate,endDate) => {
        setDebtorData(prevState => ({
            ...prevState,
            ['start_date']: startDate,
            ['end_date']: endDate,
            ['status']: 'Pending',
            ['contract_date']: formattedDate
        }));
    };

    const handleRentCreate = async(e) => {
        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;
            // console.log('productdata',productData);
            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if (debtorData.allproduct[0].id !== '') {
              } else {
                toast.warn("Please input a product name", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }
            if (debtorData.allproduct[0].quantity !== 0 && debtorData.allproduct[0].quantity !== '') {
              } else {
                toast.warn("Please input a quantity", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }
            if (debtorData.contractor !== '') {
            } else {
                toast.warn("Please input a contractor name", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                    });
                return;
            }
            if (debtorData.contractor_email !== '') {
                } else {
                toast.warn("Please input a email", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                    });
                return;
            }
            if (debtorData.start_date !== '') {
                } else {
                toast.warn("Please Select a Period", {
                    className: 'centered-toast0',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                    });
                return;
            }
            // console.log('debtorData',debtorData);
            const response = await axios.post(`${POCBaseUrl}/debtors/create`, {debtorData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                // console.log(response.data.message);
                toast.success('Rent created successfully!', {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    // draggable: true,
                    pauseOnFocusLoss: true
                  });
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    return (
        <>
            <div className=" flex mt-2.5 bg-[#f0f0f0] rounded-[5px] list-table-scroll">
                <div className="w-[600px] ml-[25px] mt-2.5 pr-[40px] border-r border-white">
                    <div className='mb-[22px] flex'>
                        <Label text={'Product'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <select className='w-[360px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500'
                                name={'id'} value={debtorData.allproduct[0].id || ''} onChange={handleProductChange} placeholder={'Select a product'}>
                                <option value="" disabled className='text-gray-500'>Select a Product</option>
                                {productList.map((item) => (
                                    <option key={item._id} value={item._id}>
                                        {item.brand} - {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Quantity'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField name = {'quantity'} type={'number'} value={debtorData.allproduct[0].quantity || ''} onChange={handleProductChange} placeholder={'Quantity'} className={'!text-[#5a5655]'}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Price(€)/monthly'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField name = {'total_price'} type={'number'} value={debtorData.total_price || ''} onChange={handleProductChange} placeholder={'Total Price'} className={'!text-[#5a5655] cursor-not-allowed'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Company'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <select className='w-[272px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500'
                                name={'contractor'} value={debtorData.contractor || ''} onChange={handleProductChange} placeholder={'Select a Company'}>
                                <option value="" disabled className='text-gray-500'>Select a Company</option>
                                {customerList.map((item) => (
                                    <option key={item._id} value={item._id}>
                                        {item.number} - {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <Button children={'Add'} onClick={()=>setAddCustomerOpen(true)}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Period'} />
                        <div className='relative text-[14px] leading-[40px] !w-[280px]'>
                            <DateRangePicker onSendData={handleDataFromChild} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-2.5 bg-[#f0f0f0]'>
                <button onClick={handleRentCreate} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2 px-24 rounded text-white cursor-pointer'>
                    Create
                </button>
            </div>
            {addCustomerOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[500px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Add New Customer</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setAddCustomerOpen(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Company Number:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        name='number'
                                        value={newCustomer.number}
                                        placeholder={'Company Number'}
                                        onChange={handleCustomerChange}
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Company Name:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='name'
                                        value={newCustomer.name}
                                        placeholder={'Company Name'}
                                        onChange={handleCustomerChange}
                                        // className="p-0 pl-[15px] w-[350px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Company Email:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='email'
                                        value={newCustomer.email}
                                        placeholder={'Company Email'}
                                        onChange={handleCustomerChange}
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Phone Number:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        name='phone'
                                        value={newCustomer.phone}
                                        placeholder={'Customer Phone'}
                                        onChange={handleCustomerChange}
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px] !mb-[5px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'>Address :</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='address1'
                                        value={newCustomer.address1}
                                        placeholder={'Address'}
                                        onChange={handleCustomerChange}
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px] !mt-[5px] !mb-[5px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'></span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='address2'
                                        value={newCustomer.address2}
                                        placeholder={'City'}
                                        onChange={handleCustomerChange}
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px] !mt-[5px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'></span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='address3'
                                        value={newCustomer.address3}
                                        placeholder={'State'}
                                        onChange={handleCustomerChange}
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px] !mt-[5px]'>
                                <span className='w-[110px] text-[#5a5655] text-[14px]'></span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        autoComplete="off"
                                        name='postal_code'
                                        value={newCustomer.postal_code}
                                        placeholder={'Postal Code'}
                                        onChange={handleCustomerChange}
                                        className="w-[350px] bg-white border border-[#dcdfe6] rounded box-border inline-block text-inherit !h-[40px] leading-[40px] outline-none pl-[15px] focus-within:ring-1 focus-within:ring-blue-500"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="pt-3 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[300px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                                onClick={handleCustomerCreate}
                            >
                                ADD
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CreateRent;